<template>
  <bita-modal
    id="product-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoadingModal"
    @close="reset()"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="type"
              label="عنوان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.title"
            />
            <bita-input
              type="number"
              name="order"
              label="اولویت"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              subtitle="اولویت نمایش در صفحه"
              v-model="formData.order"
            />
            <bita-texteditor
              name="descriptionz"
              ref="descriptionTextarea"
              label="توضیحات"
              rules=""
              validation-container-class="col-12"
              input-class="form-control"
              v-model="formData.description"
            />
            <bita-uploader
              name="logo"
              label="تصویر"
              ref="icon"
              rules="size:50"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.icon"
              :icon-url="formData.icon_url"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="create"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
import { productCollectionApi } from "@/api/apiManagement";

export default {
  props: {
    title: String,
  },
  data() {
    return {
      isLoadingModal: false,
      colWidth: "col-lg-4",
      formData: {},
    };
  },
  methods: {
    setInitialData(_data) {
      this.formData = _data;
      this.$refs.descriptionTextarea.setInitialValue(_data.description);
    },
    create() {
      this.$refs.form.validate()
        .then((res) => {
          if (res) {
            this.isLoadingModal = true;
            productCollectionApi.post( this.$getFormData(this.formData) )
              .then( (res) => {
                this.$izitoast("success", "موفق!", res.data.message);
                this.$emit("load-data");
                this.$toggleModal("#product-form");
              })
              .finally( () => this.isLoadingModal = false );
          }
      });
    },
    update() {
      this.$refs.form.validate()
        .then((res) => {
          if (res) {
            this.isLoadingModal = true;
            let data = {
              title: this.formData.title,
              type: this.formData.type,
              limit: this.formData.limit,
              order: this.formData.order,
              icon: this.formData.icon
            };
            productCollectionApi.patch(this.formData.id, this.$getFormData(data) )
              .then( (res) => {
                this.$izitoast("success", "موفق!", res.data.message);
                this.$emit("load-data");
                this.$toggleModal("#product-form");
              })
              .finally( () => this.isLoadingModal = false );
          }
      });
    },
    reset() {
      this.formData = {};
      this.$refs.form.reset();
      this.$refs.icon.reset();
      this.$refs.descriptionTextarea.reset();
    },
  },
};
</script>
